<template>
  <section v-if="spotCards.length" class="ni-section ni-spots" id="qingdao-world">
    <div class="ni-container">
      <SectionHeader
        variant="dark"
        :subtitle="lang === 'zh' ? 'THE WORLD IS IN QINGDAO' : 'THE WORLD IS IN QINGDAO'"
        more-href="/tale"
        :lang="lang"
      >
        <template #title>
          <span class="ni-section-header__title-mark">
            {{ lang === 'zh' ? '山海名城 活力青岛' : 'Vibrant City of Mountains & Sea' }}
          </span>
        </template>
      </SectionHeader>

      <div class="ni-spots__grid">
        <a
          v-for="(spot, index) in spotCards"
          :key="spot.id"
          :id="`spot-card-${spot.id}`"
          class="ni-spots__card"
          :href="spot.href"
          :title="spot.title"
        >
          <div class="ni-spots__media">
            <img :src="spot.imageUrl" :alt="spot.title" />
          </div>

          <div class="ni-spots__footer">
            <p class="ni-spots__label">{{ getDisplayLabel(index, spot) }}</p>
            <span class="ni-spots__date">{{ spot.date }}</span>
          </div>
        </a>
      </div>
    </div>
  </section>
</template>

<script>
import SectionHeader from './shared/SectionHeader.vue';

const SPOT_LABELS = [
  { zh: '青岛故事简介', en: 'Qingdao Story Intro' },
  { zh: '青岛越有young简介', en: 'Qingdao is YOUNG Intro' },
  { zh: '全民阅读简介', en: 'Public Reading Intro' },
  { zh: '青年榜young简介', en: 'Youth List YOUNG Intro' },
];

export default {
  name: 'SpotsGrid',
  components: { SectionHeader },
  props: {
    lang: { type: String, default: 'zh' },
    spotCards: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getDisplayLabel(index, spot) {
      if (spot.title) return spot.title;
      const labels = SPOT_LABELS[index];
      if (!labels) return '';
      return this.lang === 'zh' ? labels.zh : labels.en;
    },
  },
};
</script>
